import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const COMMUNICATION_SIDEBAR_DATA = [
  {
    header: 'EMAILER SNOOZING',
    tabs: [
      {
        tabName: 'Personalised Mentee Emailers',
        to: '/communication-management/personalised-mentee-mailer/',
        subject: PERMISSION_SUBJECTS.blacklist,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default COMMUNICATION_SIDEBAR_DATA;
